import React, { useEffect, useRef } from "react";

// contentEditable that only syncs from props while not focused, so the caret never jumps.
export function InlineText({ value, onChange, className, style, placeholder, testid, multiline = true }) {
  const ref = useRef(null);
  useEffect(() => { const el = ref.current; if (el && document.activeElement !== el && el.innerText !== (value || "")) el.innerText = value || ""; }, [value]);
  return (
    <div ref={ref} contentEditable suppressContentEditableWarning spellCheck={false}
      onInput={(e) => onChange(e.currentTarget.innerText.replace(/\n$/, ""))}
      onKeyDown={(e) => { if (!multiline && e.key === "Enter") e.preventDefault(); }}
      data-placeholder={placeholder} data-testid={testid}
      className={`outline-none focus:ring-1 focus:ring-[#D4AF37]/60 rounded-[2px] empty:before:content-[attr(data-placeholder)] empty:before:opacity-40 empty:before:italic ${className || ""}`}
      style={{ whiteSpace: "pre-wrap", ...style }} />
  );
}
